'use strict';

import angular from 'angular';
import LoginController from './login.controller';

export default angular.module('aperamApp.login', [])
  .controller('LoginController', LoginController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/login/index.js